<div class="unauthorized-container">
  <div class="unauthorized-content">
    <div class="icon-container">
      <span class="k-icon k-i-lock k-icon-xxl"></span>
    </div>
    <h1>Access Denied</h1>
    <p class="message">
      You don't have permission to access this page.
      Please contact your administrator if you believe this is an error.
    </p>
    <button kendoButton themeColor="primary" (click)="goBack()">
      Go to Home
    </button>
  </div>
</div>
